import { render, staticRenderFns } from "./RemoteComponent.vue?vue&type=template&id=5a0c932a&"
import script from "./RemoteComponent.vue?vue&type=script&lang=js&"
export * from "./RemoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RemoteComponent.vue?vue&type=style&index=0&id=5a0c932a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports